/**
 * Veeroute.Delivery
 * Veeroute Delivery API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Conversion settings.
 */
export interface ConvertSettingsDelivery { 
    /**
     * Route number to start the conversion. If not specified - the conversion starts from the 1st route. 
     */
    route_index_from?: number;
    /**
     * Route number to finish the conversion. If not specified - the conversion finishes on the last route. 
     */
    route_index_to?: number;
}

